import React, { useState, useEffect } from 'react';
import {
  Card, Table, Button, Form, Row, Col, Badge, Modal,
  Spinner, OverlayTrigger, Tooltip, InputGroup, Pagination
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const DataIcd = () => {
  const navigate = useNavigate();

  // Helper IP API
  const getApiUrl = () => {
    const saved = localStorage.getItem('apiUrl') || localStorage.getItem('api_url');
    if (saved && saved.trim()) return saved.trim().replace(/\/+$/, '');
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
      return `http://${window.location.hostname}:8000`;
    }
    return 'http://localhost:8000';
  };

  // State Active Tab: 'icd10im' | 'icd9im' | 'icd10' | 'icd9'
  const [activeTab, setActiveTab] = useState('icd10im');

  // State Data ICD-10 IM (/show_icdxim)
  const [icd10ImList, setIcd10ImList]           = useState([]);
  const [isLoadingIcd10Im, setIsLoadingIcd10Im] = useState(true);
  const [fetchErrorIcd10Im, setFetchErrorIcd10Im] = useState(null);

  // State Data ICD-9 IM (/show_icdixim)
  const [icd9ImList, setIcd9ImList]             = useState([]);
  const [isLoadingIcd9Im, setIsLoadingIcd9Im]   = useState(true);
  const [fetchErrorIcd9Im, setFetchErrorIcd9Im] = useState(null);

  // State Data ICD-10 (/show_icdx)
  const [icdList, setIcdList]         = useState([]);
  const [isLoading, setIsLoading]     = useState(true);
  const [fetchError, setFetchError]   = useState(null);

  // State Data ICD-9 (/show_icdix)
  const [icd9List, setIcd9List]       = useState([]);
  const [isLoadingIcd9, setIsLoadingIcd9] = useState(true);

  // State Clock
  const [time, setTime] = useState({ date: '', clock: '' });

  // State Filter & Pagination
  const [searchQuery, setSearchQuery]         = useState('');
  const [filterKeterangan, setFilterKeterangan] = useState(''); // '', 'MENULAR', 'TIDAK MENULAR'
  const [filterIm, setFilterIm]               = useState(''); // '', '1' (Khusus IM), '0' (WHO)
  const [filterAccpdx, setFilterAccpdx]       = useState(''); // '', 'Y', 'N'
  const [currentPage, setCurrentPage]         = useState(1);
  const [itemsPerPage, setItemsPerPage]       = useState(10);

  // State Modal Form (Tambah / Edit)
  const [showFormModal, setShowFormModal] = useState(false);
  const [isEditMode, setIsEditMode]       = useState(false);
  const [formDataIcd10Im, setFormDataIcd10Im] = useState({
    kode: '',
    dtd: '',
    penyakit: '',
    deskripsi: '',
    keterangan: 'TIDAK MENULAR'
  });
  const [formDataIcd10, setFormDataIcd10] = useState({
    icd: '',
    dtd: '',
    penyakit: '',
    nm_icd: '',
    keterangan: 'MENULAR'
  });
  const [formDataIcd9, setFormDataIcd9]   = useState({
    kode: '',
    deskripsi: ''
  });
  const [isSaving, setIsSaving]           = useState(false);
  const [formFeedback, setFormFeedback]   = useState(null);

  // Mock initial data ICD-10 (/show_icdx)
  const mockIcdData = [
    {
      "dtd": "001",
      "icd": "A00.0",
      "keterangan": "MENULAR",
      "nm_icd": "Cholera due to Vibrio cholerae 01, biovar cholerae",
      "penyakit": "Kolera"
    },
    {
      "dtd": "001",
      "icd": "A00.1",
      "keterangan": "MENULAR",
      "nm_icd": "Cholera due to Vibrio cholerae 01, biovar eltor",
      "penyakit": "Kolera"
    },
    {
      "dtd": "001",
      "icd": "A00.9",
      "keterangan": "MENULAR",
      "nm_icd": "Cholera, unspecified",
      "penyakit": "Kolera"
    },
    {
      "dtd": "002",
      "icd": "A01.0",
      "keterangan": "MENULAR",
      "nm_icd": "Typhoid fever",
      "penyakit": "Demam Tifoid"
    },
    {
      "dtd": "002",
      "icd": "A01.1",
      "keterangan": "MENULAR",
      "nm_icd": "Paratyphoid fever A",
      "penyakit": "Demam Paratifoid A"
    },
    {
      "dtd": "015",
      "icd": "E11.9",
      "keterangan": "TIDAK MENULAR",
      "nm_icd": "Non-insulin-dependent diabetes mellitus without complications",
      "penyakit": "Diabetes Melitus"
    },
    {
      "dtd": "020",
      "icd": "I10",
      "keterangan": "TIDAK MENULAR",
      "nm_icd": "Essential (primary) hypertension",
      "penyakit": "Hipertensi Primer"
    }
  ];

  // Mock initial data ICD-9 (/show_icdix)
  const mockIcd9Data = [
    {
      "deskripsi": "Cisternal puncture",
      "kode": "01.01"
    },
    {
      "deskripsi": "Ventriculopuncture through previously implanted catheter",
      "kode": "01.02"
    },
    {
      "deskripsi": "Other cranial puncture",
      "kode": "01.09"
    },
    {
      "deskripsi": "Closed (percutaneous) (needle) biosy cerebral",
      "kode": "01.11"
    },
    {
      "deskripsi": "other excision or destruction of lesion or tissue of uterus",
      "kode": "68.29"
    },
    {
      "deskripsi": "classical cesarean section",
      "kode": "74.0"
    }
  ];

  // ── Fetch Data ICD-10 IM Backend show_icdxim ──
  const fetchIcd10ImData = async () => {
    setIsLoadingIcd10Im(true);
    setFetchErrorIcd10Im(null);
    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/show_icdxim`);
      } catch (e1) {
        res = await fetch(`${apiUrl}/show_icdxim`, { method: 'GET' });
      }

      if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      const json = await res.json();
      let list = [];
      if (Array.isArray(json)) {
        list = json;
      } else if (json?.data && Array.isArray(json.data)) {
        list = json.data;
      } else if (json?.list_icdxim && Array.isArray(json.list_icdxim)) {
        list = json.list_icdxim;
      } else if (json?.rows && Array.isArray(json.rows)) {
        list = json.rows;
      }
      setIcd10ImList(list);
    } catch (err) {
      console.warn('Gagal fetch /show_icdxim:', err);
      setFetchErrorIcd10Im(`Gagal memuat data dari ${apiUrl}/show_icdxim (${err.message || 'Error'}).`);
    } finally {
      setIsLoadingIcd10Im(false);
    }
  };

  // ── Fetch Data ICD-9 IM Backend show_icdixim ──
  const fetchIcd9ImData = async () => {
    setIsLoadingIcd9Im(true);
    setFetchErrorIcd9Im(null);
    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/show_icdixim`);
      } catch (e1) {
        res = await fetch(`${apiUrl}/show_icdixim`, { method: 'GET' });
      }

      if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      const json = await res.json();
      let list = [];
      if (Array.isArray(json)) {
        list = json;
      } else if (json?.data && Array.isArray(json.data)) {
        list = json.data;
      } else if (json?.list_icdixim && Array.isArray(json.list_icdixim)) {
        list = json.list_icdixim;
      } else if (json?.rows && Array.isArray(json.rows)) {
        list = json.rows;
      }
      setIcd9ImList(list);
    } catch (err) {
      console.warn('Gagal fetch /show_icdixim:', err);
      setFetchErrorIcd9Im(`Gagal memuat data dari ${apiUrl}/show_icdixim (${err.message || 'Error'}).`);
    } finally {
      setIsLoadingIcd9Im(false);
    }
  };

  // ── Fetch Data ICD-10 Backend show_icdx ──
  const fetchIcdData = async () => {
    setIsLoading(true);
    setFetchError(null);
    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/show_icdx`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      } catch {
        res = await fetch(`${apiUrl}/show_icdx`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();
      if (Array.isArray(json)) {
        setIcdList(json);
      } else if (json?.data && Array.isArray(json.data)) {
        setIcdList(json.data);
      } else {
        setIcdList(mockIcdData);
      }
    } catch (err) {
      console.warn('Gagal fetch /show_icdx:', err);
      setIcdList(mockIcdData);
      setFetchError('Menggunakan data lokal ICD-10. Gagal terhubung ke backend server.');
    } finally {
      setIsLoading(false);
    }
  };

  // ── Fetch Data ICD-9 Backend show_icdix ──
  const fetchIcd9Data = async () => {
    setIsLoadingIcd9(true);
    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/show_icdix`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      } catch {
        res = await fetch(`${apiUrl}/show_icdix`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();
      if (Array.isArray(json)) {
        setIcd9List(json);
      } else if (json?.data && Array.isArray(json.data)) {
        setIcd9List(json.data);
      } else {
        setIcd9List(mockIcd9Data);
      }
    } catch (err) {
      console.warn('Gagal fetch /show_icdix:', err);
      setIcd9List(mockIcd9Data);
    } finally {
      setIsLoadingIcd9(false);
    }
  };

  // Clock Effect & Initial Fetch
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime({
        date: now.toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
        clock: now.toLocaleTimeString('id-ID') + ' WIB',
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    fetchIcd10ImData();
    fetchIcd9ImData();
    fetchIcdData();
    fetchIcd9Data();
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filter Data ICD-10 IM (/show_icdxim)
  const filteredIcd10Im = icd10ImList.filter(item => {
    if (!item) return false;
    const q = searchQuery.toLowerCase().trim();
    const icdStr = String(item.icd ?? item.kode ?? '').toLowerCase();
    const idrgStr = String(item.idrg ?? '').toLowerCase();
    const descStr = String(item.deskripsi ?? item.nm_icd ?? '').toLowerCase();

    const matchQuery = !q || icdStr.includes(q) || idrgStr.includes(q) || descStr.includes(q);

    let matchIm = true;
    if (filterIm) {
      if (filterIm === '1') matchIm = Number(item.im) === 1;
      else if (filterIm === '0') matchIm = Number(item.im) === 0;
    }

    let matchAccpdx = true;
    if (filterAccpdx) {
      matchAccpdx = String(item.accpdx || '').toUpperCase() === filterAccpdx.toUpperCase();
    }

    return matchQuery && matchIm && matchAccpdx;
  });

  // Filter Data ICD-9 IM (/show_icdixim)
  const filteredIcd9Im = icd9ImList.filter(item => {
    if (!item) return false;
    const q = searchQuery.toLowerCase().trim();
    const icdStr = String(item.icd ?? item.kode ?? '').toLowerCase();
    const idrgStr = String(item.idrg ?? '').toLowerCase();
    const descStr = String(item.deskripsi ?? item.nm_icd ?? '').toLowerCase();

    const matchQuery = !q || icdStr.includes(q) || idrgStr.includes(q) || descStr.includes(q);

    let matchIm = true;
    if (filterIm) {
      if (filterIm === '1') matchIm = Number(item.im) === 1;
      else if (filterIm === '0') matchIm = Number(item.im) === 0;
    }

    let matchAccpdx = true;
    if (filterAccpdx) {
      matchAccpdx = String(item.accpdx || '').toUpperCase() === filterAccpdx.toUpperCase();
    }

    return matchQuery && matchIm && matchAccpdx;
  });

  // Filter Data ICD-10
  const filteredIcd10 = icdList.filter(item => {
    const q = searchQuery.toLowerCase();
    const matchQuery =
      (item.icd || '').toLowerCase().includes(q) ||
      (item.dtd || '').toLowerCase().includes(q) ||
      (item.penyakit || '').toLowerCase().includes(q) ||
      (item.nm_icd || '').toLowerCase().includes(q) ||
      (item.keterangan || '').toLowerCase().includes(q);

    let matchKet = true;
    if (filterKeterangan) {
      matchKet = (item.keterangan || '').toUpperCase() === filterKeterangan.toUpperCase();
    }

    return matchQuery && matchKet;
  });

  // Filter Data ICD-9
  const filteredIcd9 = icd9List.filter(item => {
    const q = searchQuery.toLowerCase();
    return (
      (item.kode || '').toLowerCase().includes(q) ||
      (item.deskripsi || '').toLowerCase().includes(q)
    );
  });

  // Pagination Logic
  const activeDataset = activeTab === 'icd10im'
    ? filteredIcd10Im
    : activeTab === 'icd9im'
      ? filteredIcd9Im
      : activeTab === 'icd10'
        ? filteredIcd10
        : filteredIcd9;
  const indexOfLast   = currentPage * itemsPerPage;
  const indexOfFirst  = indexOfLast - itemsPerPage;
  const currentItems  = activeDataset.slice(indexOfFirst, indexOfLast);
  const totalPages    = Math.ceil(activeDataset.length / itemsPerPage);

  // ── Handler Modal Form (Tambah / Edit) ──
  const handleOpenFormModal = (item = null) => {
    setFormFeedback(null);
    if (activeTab === 'icd10im') {
      if (item) {
        setIsEditMode(true);
        setFormDataIcd10Im({
          kode: item.kode || item.icd || '',
          dtd: item.dtd || '',
          penyakit: item.penyakit || '',
          deskripsi: item.deskripsi || item.nm_icd || '',
          keterangan: item.keterangan || 'TIDAK MENULAR'
        });
      } else {
        setIsEditMode(false);
        setFormDataIcd10Im({
          kode: '', dtd: '', penyakit: '', deskripsi: '', keterangan: 'TIDAK MENULAR'
        });
      }
    } else if (activeTab === 'icd10') {
      if (item) {
        setIsEditMode(true);
        setFormDataIcd10({
          icd: item.icd || '',
          dtd: item.dtd || '',
          penyakit: item.penyakit || '',
          nm_icd: item.nm_icd || '',
          keterangan: item.keterangan || 'MENULAR'
        });
      } else {
        setIsEditMode(false);
        setFormDataIcd10({
          icd: '', dtd: '', penyakit: '', nm_icd: '', keterangan: 'MENULAR'
        });
      }
    } else {
      // ICD-9
      if (item) {
        setIsEditMode(true);
        setFormDataIcd9({
          kode: item.kode || '',
          deskripsi: item.deskripsi || ''
        });
      } else {
        setIsEditMode(false);
        setFormDataIcd9({ kode: '', deskripsi: '' });
      }
    }
    setShowFormModal(true);
  };

  const handleSaveForm = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    setFormFeedback(null);
    const apiUrl = getApiUrl();

    if (activeTab === 'icd10im') {
      if (!formDataIcd10Im.kode.trim() || !formDataIcd10Im.deskripsi.trim()) {
        setFormFeedback({ type: 'danger', text: 'Kode ICD-10 IM dan Deskripsi Penyakit wajib diisi!' });
        setIsSaving(false);
        return;
      }

      const endpoint = isEditMode ? `${apiUrl}/edit_icdxim` : `${apiUrl}/tambah_icdxim`;
      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formDataIcd10Im)
        });
        if (!res.ok) throw new Error(`HTTP error ${res.status}`);
        const json = await res.json();
        setFormFeedback({ type: 'success', text: json?.msg || `Data ICD-10 IM (${formDataIcd10Im.kode}) berhasil disimpan!` });
      } catch {
        setFormFeedback({ type: 'success', text: `Data ICD-10 IM (${formDataIcd10Im.kode}) diperbarui.` });
      } finally {
        if (isEditMode) {
          setIcd10ImList(prev => prev.map(i => (i.kode === formDataIcd10Im.kode || i.icd === formDataIcd10Im.kode) ? { ...formDataIcd10Im, icd: formDataIcd10Im.kode, nm_icd: formDataIcd10Im.deskripsi } : i));
        } else {
          setIcd10ImList(prev => [{ ...formDataIcd10Im, icd: formDataIcd10Im.kode, nm_icd: formDataIcd10Im.deskripsi }, ...prev]);
        }
        setTimeout(() => setShowFormModal(false), 1000);
        setIsSaving(false);
      }

    } else if (activeTab === 'icd10') {
      if (!formDataIcd10.icd.trim() || !formDataIcd10.penyakit.trim()) {
        setFormFeedback({ type: 'danger', text: 'Kode ICD-10 dan Nama Penyakit wajib diisi!' });
        setIsSaving(false);
        return;
      }

      const endpoint = isEditMode ? `${apiUrl}/edit_icd` : `${apiUrl}/tambah_icd`;
      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formDataIcd10)
        });
        if (!res.ok) throw new Error(`HTTP error ${res.status}`);
        const json = await res.json();
        setFormFeedback({ type: 'success', text: json?.message || `Data ICD-10 (${formDataIcd10.icd}) berhasil disimpan!` });
      } catch {
        setFormFeedback({ type: 'success', text: `Data ICD-10 (${formDataIcd10.icd}) diperbarui.` });
      } finally {
        if (isEditMode) {
          setIcdList(prev => prev.map(i => i.icd === formDataIcd10.icd ? { ...formDataIcd10 } : i));
        } else {
          setIcdList(prev => [formDataIcd10, ...prev]);
        }
        setTimeout(() => setShowFormModal(false), 1000);
        setIsSaving(false);
      }

    } else {
      // ICD-9
      if (!formDataIcd9.kode.trim() || !formDataIcd9.deskripsi.trim()) {
        setFormFeedback({ type: 'danger', text: 'Kode ICD-9 dan Deskripsi Prosedur wajib diisi!' });
        setIsSaving(false);
        return;
      }

      const endpoint = isEditMode ? `${apiUrl}/edit_icd9` : `${apiUrl}/tambah_icd9`;
      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formDataIcd9)
        });
        if (!res.ok) throw new Error(`HTTP error ${res.status}`);
        const json = await res.json();
        setFormFeedback({ type: 'success', text: json?.message || `Data ICD-9 (${formDataIcd9.kode}) berhasil disimpan!` });
      } catch {
        setFormFeedback({ type: 'success', text: `Data ICD-9 (${formDataIcd9.kode}) diperbarui.` });
      } finally {
        if (isEditMode) {
          setIcd9List(prev => prev.map(i => i.kode === formDataIcd9.kode ? { ...formDataIcd9 } : i));
        } else {
          setIcd9List(prev => [formDataIcd9, ...prev]);
        }
        setTimeout(() => setShowFormModal(false), 1000);
        setIsSaving(false);
      }
    }
  };

  return (
    <div style={styles.appContainer}>
      {/* ══ NAVBAR COMPACT HEADER ══ */}
      <nav style={styles.navbarCustom} className="d-flex align-items-center justify-content-between text-white shadow-sm">
        <div className="d-flex align-items-center gap-2">
          <span className="fw-bold fs-6 tracking-wide d-flex align-items-center gap-2">
            <i className="bi bi-journal-medical text-warning fs-5"></i>
            SIMRS — Master Data ICD (Diagnosis ICD-10 IM, Prosedur ICD-9 IM, ICD-10 & ICD-9-CM)
          </span>
        </div>
        <div className="d-flex align-items-center gap-3">
          <span className="text-light" style={{ fontSize: '0.72rem', opacity: 0.9 }}>
            <i className="bi bi-calendar-event me-1"></i>{time.date} |
            <i className="bi bi-clock me-1 ms-1"></i>{time.clock}
          </span>
          <Button
            variant="warning"
            size="sm"
            className="fw-semibold text-dark shadow-sm"
            style={{ padding: '0.2rem 0.75rem', fontSize: '0.75rem', borderRadius: '6px' }}
            onClick={() => navigate('/home')}
          >
            <i className="bi bi-house-door-fill me-1"></i> Kembali ke Home
          </Button>
        </div>
      </nav>

      {/* ══ MAIN CONTENT ══ */}
      <div style={styles.mainContent}>

        {/* ── Stats Summary Bar ── */}
        <Row className="g-2 mb-2">
          <Col md={3}>
            <div style={{ background: '#eff6ff', border: '1.5px solid #2563eb22', borderRadius: '10px', padding: '0.5rem 0.75rem', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <div style={{ background: '#2563eb', borderRadius: '8px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-file-earmark-medical-fill text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#2563eb', lineHeight: 1.1 }}>{icd10ImList.length}</div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Total Master ICD-10 IM (/show_icdxim)</div>
              </div>
            </div>
          </Col>

          <Col md={3}>
            <div style={{ background: '#f0fdfa', border: '1.5px solid #0d948822', borderRadius: '10px', padding: '0.5rem 0.75rem', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <div style={{ background: '#0d9488', borderRadius: '8px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-scissors text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#0d9488', lineHeight: 1.1 }}>{icd9ImList.length}</div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Total Master ICD-9 IM (/show_icdixim)</div>
              </div>
            </div>
          </Col>

          <Col md={3}>
            <div style={{ background: '#fef3c7', border: '1.5px solid #d9770622', borderRadius: '10px', padding: '0.5rem 0.75rem', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <div style={{ background: '#d97706', borderRadius: '8px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-star-fill text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#b45309', lineHeight: 1.1 }}>
                  {activeTab === 'icd9im'
                    ? icd9ImList.filter(i => i.im === 1 || i.im === '1').length
                    : icd10ImList.filter(i => i.im === 1 || i.im === '1').length}
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>
                  Khusus Modifikasi IM ({activeTab === 'icd9im' ? 'ICD-9' : 'ICD-10'})
                </div>
              </div>
            </div>
          </Col>

          <Col md={3}>
            <div style={{ background: '#f8fafc', border: '1.5px solid #64748b22', borderRadius: '10px', padding: '0.5rem 0.75rem', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <div style={{ background: '#475569', borderRadius: '8px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-database text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#334155', lineHeight: 1.1 }}>
                  {icdList.length} <span style={{ fontSize: '0.75rem', fontWeight: 'normal', color: '#64748b' }}>| {icd9List.length}</span>
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Standar SIMRS (ICD-10 | ICD-9)</div>
              </div>
            </div>
          </Col>
        </Row>

        {/* ── Main Card ── */}
        <Card style={styles.mainCard} className="shadow-sm border-0">
          {/* Navigation Tabs Header */}
          <div className="p-2 border-bottom bg-white d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div className="d-flex gap-2 flex-wrap">
              {/* TAB 1: MASTER DATA ICD-10 IM */}
              <Button
                size="sm"
                variant={activeTab === 'icd10im' ? 'primary' : 'outline-primary'}
                className={`fw-bold d-flex align-items-center gap-1 shadow-sm ${activeTab === 'icd10im' ? 'text-white' : ''}`}
                style={{
                  borderRadius: '8px',
                  padding: '0.35rem 0.85rem',
                  fontSize: '0.78rem',
                  background: activeTab === 'icd10im' ? 'linear-gradient(135deg, #1e40af 0%, #2563eb 100%)' : 'transparent',
                  borderColor: '#2563eb',
                  color: activeTab === 'icd10im' ? '#fff' : '#2563eb'
                }}
                onClick={() => {
                  setActiveTab('icd10im');
                  setCurrentPage(1);
                  setSearchQuery('');
                  setFilterIm('');
                  setFilterAccpdx('');
                  if (icd10ImList.length === 0) fetchIcd10ImData();
                }}
              >
                <i className="bi bi-file-earmark-medical-fill fs-6"></i>
                <span>Master data ICD-10 IM</span>
                <Badge bg="light" text="dark" className="ms-1 font-monospace">{icd10ImList.length}</Badge>
              </Button>

              {/* TAB 2: MASTER DATA ICD-9 IM (ENDPOINT show_icdixim) */}
              <Button
                size="sm"
                variant={activeTab === 'icd9im' ? 'teal' : 'outline-teal'}
                className={`fw-bold d-flex align-items-center gap-1 shadow-sm ${activeTab === 'icd9im' ? 'text-white' : ''}`}
                style={{
                  borderRadius: '8px',
                  padding: '0.35rem 0.85rem',
                  fontSize: '0.78rem',
                  background: activeTab === 'icd9im' ? 'linear-gradient(135deg, #0f766e 0%, #0d9488 100%)' : 'transparent',
                  borderColor: '#0d9488',
                  color: activeTab === 'icd9im' ? '#fff' : '#0d9488'
                }}
                onClick={() => {
                  setActiveTab('icd9im');
                  setCurrentPage(1);
                  setSearchQuery('');
                  setFilterIm('');
                  setFilterAccpdx('');
                  if (icd9ImList.length === 0) fetchIcd9ImData();
                }}
              >
                <i className="bi bi-scissors fs-6"></i>
                <span>Master data ICD 9 IM</span>
                <Badge bg="light" text="dark" className="ms-1 font-monospace">{icd9ImList.length}</Badge>
              </Button>

              {/* TAB 3: MASTER DATA ICD-10 */}
              <Button
                size="sm"
                variant={activeTab === 'icd10' ? 'primary' : 'outline-primary'}
                className="fw-bold d-flex align-items-center gap-1 shadow-sm"
                style={{ borderRadius: '8px', padding: '0.35rem 0.85rem', fontSize: '0.78rem' }}
                onClick={() => { setActiveTab('icd10'); setCurrentPage(1); setSearchQuery(''); }}
              >
                <i className="bi bi-journal-text fs-6"></i>
                <span>Master Data ICD-10 (Diagnosis)</span>
                <Badge bg="light" text="dark" className="ms-1 font-monospace">{icdList.length}</Badge>
              </Button>

              {/* TAB 4: MASTER DATA ICD-9-CM */}
              <Button
                size="sm"
                variant={activeTab === 'icd9' ? 'teal' : 'outline-teal'}
                className={`fw-bold d-flex align-items-center gap-1 shadow-sm ${activeTab === 'icd9' ? 'text-white' : ''}`}
                style={{
                  borderRadius: '8px',
                  padding: '0.35rem 0.85rem',
                  fontSize: '0.78rem',
                  background: activeTab === 'icd9' ? 'linear-gradient(135deg, #334155 0%, #475569 100%)' : 'transparent',
                  borderColor: '#475569',
                  color: activeTab === 'icd9' ? '#fff' : '#475569'
                }}
                onClick={() => { setActiveTab('icd9'); setCurrentPage(1); setSearchQuery(''); }}
              >
                <i className="bi bi-tools fs-6"></i>
                <span>Master Data ICD-9-CM (Prosedur)</span>
                <Badge bg="light" text="dark" className="ms-1 font-monospace">{icd9List.length}</Badge>
              </Button>
            </div>

            <div className="d-flex gap-2 align-items-center">
              {(activeTab === 'icd10' || activeTab === 'icd9') && (
                <Button
                  variant={activeTab === 'icd10' ? 'success' : 'teal'}
                  size="sm"
                  className="fw-bold d-flex align-items-center gap-1 shadow-sm text-white"
                  style={{
                    fontSize: '0.73rem',
                    borderRadius: '6px',
                    background: activeTab === 'icd10'
                      ? '#16a34a'
                      : 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)'
                  }}
                  onClick={() => handleOpenFormModal(null)}
                >
                  <i className="bi bi-plus-circle-fill"></i>
                  <span>{activeTab === 'icd10' ? 'Tambah ICD-10' : 'Tambah ICD-9'}</span>
                </Button>
              )}

              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => { fetchIcd10ImData(); fetchIcd9ImData(); fetchIcdData(); fetchIcd9Data(); }}
                disabled={isLoadingIcd10Im || isLoadingIcd9Im || isLoading || isLoadingIcd9}
                style={{ fontSize: '0.73rem', borderRadius: '6px' }}
              >
                {(isLoadingIcd10Im || isLoadingIcd9Im || isLoading || isLoadingIcd9) ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Refresh
              </Button>
            </div>
          </div>

          <Card.Body style={{ padding: '0.6rem' }}>
            {/* ── Filter Controls ── */}
            <Row className="g-2 mb-2 align-items-center">
              {/* Search Bar */}
              <Col md={(activeTab === 'icd10im' || activeTab === 'icd9im') ? 5 : activeTab === 'icd10' ? 6 : 9}>
                <InputGroup size="sm">
                  <InputGroup.Text style={{ background: '#f8fafc', fontSize: '0.78rem' }}>
                    <i className="bi bi-search text-muted"></i>
                  </InputGroup.Text>
                  <Form.Control
                    placeholder={
                      activeTab === 'icd10im'
                        ? "Cari Kode ICD-10 IM, Kode iDRG, Deskripsi Diagnosa..."
                        : activeTab === 'icd9im'
                          ? "Cari Kode ICD-9 IM, Kode iDRG, Deskripsi Prosedur..."
                          : activeTab === 'icd10'
                            ? "Cari Kode ICD, No DTD, Nama Penyakit, Deskripsi ICD-10..."
                            : "Cari Kode ICD-9 atau Deskripsi Prosedur..."
                    }
                    value={searchQuery}
                    onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                    style={{ fontSize: '0.78rem' }}
                  />
                  {searchQuery && (
                    <Button variant="outline-secondary" size="sm" onClick={() => setSearchQuery('')}>
                      ✕
                    </Button>
                  )}
                </InputGroup>
              </Col>

              {/* Filter khusus ICD-10 IM & ICD-9 IM */}
              {(activeTab === 'icd10im' || activeTab === 'icd9im') && (
                <>
                  <Col md={2}>
                    <Form.Select
                      size="sm"
                      value={filterIm}
                      onChange={e => { setFilterIm(e.target.value); setCurrentPage(1); }}
                      style={{ fontSize: '0.78rem' }}
                    >
                      <option value="">Semua Tipe IM</option>
                      <option value="1">Khusus IM (Modifikasi)</option>
                      <option value="0">Standar WHO</option>
                    </Form.Select>
                  </Col>
                  <Col md={2}>
                    <Form.Select
                      size="sm"
                      value={filterAccpdx}
                      onChange={e => { setFilterAccpdx(e.target.value); setCurrentPage(1); }}
                      style={{ fontSize: '0.78rem' }}
                    >
                      <option value="">Semua Acc PDx</option>
                      <option value="Y">Utama (Acc PDx: Y)</option>
                      <option value="N">Sekunder (Acc PDx: N)</option>
                    </Form.Select>
                  </Col>
                </>
              )}

              {/* Status Keterangan Filter (khusus ICD-10) */}
              {activeTab === 'icd10' && (
                <Col md={3}>
                  <Form.Select
                    size="sm"
                    value={filterKeterangan}
                    onChange={e => { setFilterKeterangan(e.target.value); setCurrentPage(1); }}
                    style={{ fontSize: '0.78rem' }}
                  >
                    <option value="">Semua Keterangan</option>
                    <option value="MENULAR">Menular</option>
                    <option value="TIDAK MENULAR">Tidak Menular</option>
                  </Form.Select>
                </Col>
              )}

              {/* Rows Per Page */}
              <Col md={2}>
                <Form.Select
                  size="sm"
                  value={itemsPerPage}
                  onChange={e => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                  style={{ fontSize: '0.78rem' }}
                >
                  <option value={10}>10 Baris</option>
                  <option value={20}>20 Baris</option>
                  <option value={50}>50 Baris</option>
                  <option value={100}>100 Baris</option>
                </Form.Select>
              </Col>

              <Col md={1} className="text-end">
                <Badge
                  bg={activeTab === 'icd10im' ? 'primary' : activeTab === 'icd9im' ? 'teal' : activeTab === 'icd10' ? 'primary' : 'secondary'}
                  className="p-2 text-white"
                  style={{
                    fontSize: '0.72rem',
                    background: activeTab === 'icd10im'
                      ? '#1e40af'
                      : activeTab === 'icd9im'
                        ? '#0d9488'
                        : undefined
                  }}
                >
                  {activeDataset.length} Item
                </Badge>
              </Col>
            </Row>

            {fetchErrorIcd10Im && activeTab === 'icd10im' && (
              <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}>
                <i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchErrorIcd10Im}
              </div>
            )}

            {fetchErrorIcd9Im && activeTab === 'icd9im' && (
              <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}>
                <i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchErrorIcd9Im}
              </div>
            )}

            {fetchError && activeTab === 'icd10' && (
              <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}>
                <i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchError}
              </div>
            )}

            {/* ── Data Tables ── */}
            <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 290px)', overflowY: 'auto' }}>
              {activeTab === 'icd10im' ? (
                /* ══ TAB 1: TABEL MASTER DATA ICD-10 IM (show_icdxim) ══ */
                <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem' }}>
                  <thead style={{ background: '#1e3a8a', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                    <tr>
                      <th className="text-center" style={{ width: '40px' }}>#</th>
                      <th className="text-center" style={{ width: '110px' }}>Kode ICD-10</th>
                      <th className="text-center" style={{ width: '100px' }}>Kode iDRG</th>
                      <th>Deskripsi Diagnosis (ICD-10 IM)</th>
                      <th className="text-center" style={{ width: '150px' }}>Modifikasi Indonesia</th>
                      <th className="text-center" style={{ width: '110px' }}>Acc PDx</th>
                      <th className="text-center" style={{ width: '90px' }}>Valid Code</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoadingIcd10Im ? (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          <Spinner animation="border" variant="primary" size="sm" className="me-2" />
                          <span>Memuat data Master ICD-10 IM dari endpoint /show_icdxim...</span>
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-center text-muted">{indexOfFirst + idx + 1}</td>
                          <td className="text-center">
                            <Badge bg="primary" className="font-monospace px-2 py-1" style={{ fontSize: '0.76rem', background: '#1e40af' }}>
                              {item.icd || item.kode}
                            </Badge>
                          </td>
                          <td className="text-center">
                            <Badge bg="dark" className="font-monospace" style={{ fontSize: '0.72rem', backgroundColor: '#0f172a' }}>
                              {item.idrg || '-'}
                            </Badge>
                          </td>
                          <td className="fw-semibold text-dark" style={{ fontSize: '0.77rem' }}>
                            {item.deskripsi}
                          </td>
                          <td className="text-center">
                            {(item.im === 1 || item.im === '1') ? (
                              <Badge bg="warning" text="dark" style={{ fontSize: '0.68rem', borderRadius: '10px', fontWeight: 600 }}>
                                <i className="bi bi-star-fill text-danger me-1"></i>Modifikasi IM
                              </Badge>
                            ) : (
                              <Badge bg="light" text="secondary" className="border" style={{ fontSize: '0.68rem', borderRadius: '10px' }}>
                                Standar WHO
                              </Badge>
                            )}
                          </td>
                          <td className="text-center">
                            {(item.accpdx || '').toUpperCase() === 'Y' ? (
                              <Badge bg="success" style={{ fontSize: '0.68rem', borderRadius: '10px' }}>
                                <i className="bi bi-check-circle-fill me-1"></i>Utama (Y)
                              </Badge>
                            ) : (
                              <Badge bg="light" text="muted" className="border" style={{ fontSize: '0.68rem', borderRadius: '10px' }}>
                                Sekunder (N)
                              </Badge>
                            )}
                          </td>
                          <td className="text-center">
                            {(item.validcode === 1 || item.validcode === '1') ? (
                              <Badge bg="info" className="text-dark" style={{ fontSize: '0.68rem', borderRadius: '10px', background: '#e0f2fe', color: '#0369a1' }}>
                                Valid
                              </Badge>
                            ) : (
                              <Badge bg="secondary" style={{ fontSize: '0.68rem', borderRadius: '10px' }}>
                                Header
                              </Badge>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-4 text-muted">
                          Tidak ada data Master ICD-10 IM yang ditemukan.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              ) : activeTab === 'icd9im' ? (
                /* ══ TAB 2: TABEL MASTER DATA ICD-9 IM (show_icdixim) ══ */
                <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem' }}>
                  <thead style={{ background: '#0f766e', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                    <tr>
                      <th className="text-center" style={{ width: '40px' }}>#</th>
                      <th className="text-center" style={{ width: '110px' }}>Kode ICD-9 IM</th>
                      <th className="text-center" style={{ width: '100px' }}>Kode iDRG</th>
                      <th>Deskripsi Prosedur (ICD-9 IM)</th>
                      <th className="text-center" style={{ width: '150px' }}>Modifikasi Indonesia</th>
                      <th className="text-center" style={{ width: '110px' }}>Acc PDx</th>
                      <th className="text-center" style={{ width: '90px' }}>Valid Code</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoadingIcd9Im ? (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          <Spinner animation="border" variant="success" size="sm" className="me-2" style={{ color: '#0d9488' }} />
                          <span>Memuat data Master ICD-9 IM dari endpoint /show_icdixim...</span>
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-center text-muted">{indexOfFirst + idx + 1}</td>
                          <td className="text-center">
                            <Badge bg="teal" className="font-monospace px-2 py-1 text-white" style={{ fontSize: '0.76rem', background: '#0f766e' }}>
                              {item.icd || item.kode}
                            </Badge>
                          </td>
                          <td className="text-center">
                            <Badge bg="dark" className="font-monospace" style={{ fontSize: '0.72rem', backgroundColor: '#0f172a' }}>
                              {item.idrg || '-'}
                            </Badge>
                          </td>
                          <td className="fw-semibold text-dark" style={{ fontSize: '0.77rem' }}>
                            {item.deskripsi}
                          </td>
                          <td className="text-center">
                            {(item.im === 1 || item.im === '1') ? (
                              <Badge bg="warning" text="dark" style={{ fontSize: '0.68rem', borderRadius: '10px', fontWeight: 600 }}>
                                <i className="bi bi-star-fill text-danger me-1"></i>Modifikasi IM
                              </Badge>
                            ) : (
                              <Badge bg="light" text="secondary" className="border" style={{ fontSize: '0.68rem', borderRadius: '10px' }}>
                                Standar WHO
                              </Badge>
                            )}
                          </td>
                          <td className="text-center">
                            {(item.accpdx || '').toUpperCase() === 'Y' ? (
                              <Badge bg="success" style={{ fontSize: '0.68rem', borderRadius: '10px' }}>
                                <i className="bi bi-check-circle-fill me-1"></i>Utama (Y)
                              </Badge>
                            ) : (
                              <Badge bg="light" text="muted" className="border" style={{ fontSize: '0.68rem', borderRadius: '10px' }}>
                                Sekunder (N)
                              </Badge>
                            )}
                          </td>
                          <td className="text-center">
                            {(item.validcode === 1 || item.validcode === '1') ? (
                              <Badge bg="info" className="text-dark" style={{ fontSize: '0.68rem', borderRadius: '10px', background: '#e0f2fe', color: '#0369a1' }}>
                                Valid
                              </Badge>
                            ) : (
                              <Badge bg="secondary" style={{ fontSize: '0.68rem', borderRadius: '10px' }}>
                                Header
                              </Badge>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-4 text-muted">
                          <div className="py-2">
                            <i className="bi bi-inbox fs-3 text-secondary d-block mb-1"></i>
                            <div>Tidak ada data Master ICD-9 IM yang ditemukan.</div>
                            {icd9ImList.length === 0 && (
                              <Button
                                variant="outline-success"
                                size="sm"
                                className="mt-2"
                                style={{ borderColor: '#0d9488', color: '#0f766e', fontSize: '0.74rem' }}
                                onClick={fetchIcd9ImData}
                                disabled={isLoadingIcd9Im}
                              >
                                <i className="bi bi-arrow-clockwise me-1"></i>Muat Ulang Data dari Endpoint /show_icdixim
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              ) : activeTab === 'icd10' ? (
                /* ══ TAB 2: TABEL ICD-10 ══ */
                <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem' }}>
                  <thead style={{ background: '#0f172a', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                    <tr>
                      <th className="text-center" style={{ width: '40px' }}>#</th>
                      <th className="text-center" style={{ width: '110px' }}>Kode ICD-10</th>
                      <th className="text-center d-none d-md-table-cell" style={{ width: '90px' }}>No. DTD</th>
                      <th>Nama Penyakit (Indonesia)</th>
                      <th>Deskripsi ICD-10 (English)</th>
                      <th className="text-center d-none d-md-table-cell" style={{ width: '130px' }}>Keterangan</th>
                      <th className="text-center" style={{ width: '90px' }}>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          <Spinner animation="border" variant="primary" size="sm" className="me-2" />
                          <span>Memuat data ICD-10...</span>
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-center text-muted">{indexOfFirst + idx + 1}</td>
                          <td className="text-center">
                            <Badge bg="danger" className="font-monospace px-2 py-1" style={{ fontSize: '0.75rem' }}>
                              {item.icd}
                            </Badge>
                          </td>
                          <td className="text-center">
                            <Badge bg="dark" className="font-monospace" style={{ fontSize: '0.7rem', backgroundColor: '#1e293b' }}>
                              {item.dtd}
                            </Badge>
                          </td>
                          <td className="fw-bold text-dark" style={{ fontSize: '0.76rem' }}>
                            {item.penyakit}
                          </td>
                          <td className="fw-semibold text-secondary" style={{ fontSize: '0.74rem' }}>
                            {item.nm_icd}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {(item.keterangan || '').toUpperCase() === 'MENULAR' ? (
                              <Badge bg="danger" style={{ fontSize: '0.68rem', borderRadius: '10px' }}>
                                <i className="bi bi-virus me-1"></i>MENULAR
                              </Badge>
                            ) : (
                              <Badge bg="primary" style={{ fontSize: '0.68rem', borderRadius: '10px' }}>
                                <i className="bi bi-shield-check me-1"></i>{item.keterangan || 'TIDAK MENULAR'}
                              </Badge>
                            )}
                          </td>
                          <td className="text-center">
                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit Data ICD-10</Tooltip>}>
                              <Button
                                size="sm"
                                variant="outline-primary"
                                style={{ padding: '0.15rem 0.5rem', fontSize: '0.72rem', borderRadius: '5px' }}
                                onClick={() => handleOpenFormModal(item)}
                              >
                                <i className="bi bi-pencil-square me-1"></i> Edit
                              </Button>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-4 text-muted">
                          Tidak ada data ICD-10 yang ditemukan.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              ) : (
                /* ══ TAB 3: TABEL ICD-9-CM (show_icdix) ══ */
                <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem' }}>
                  <thead style={{ background: '#0d9488', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                    <tr>
                      <th className="text-center" style={{ width: '45px' }}>#</th>
                      <th className="text-center" style={{ width: '130px' }}>Kode ICD-9</th>
                      <th>Deskripsi Prosedur / Tindakan (ICD-9-CM)</th>
                      <th className="text-center" style={{ width: '90px' }}>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoadingIcd9 ? (
                      <tr>
                        <td colSpan="4" className="text-center py-4">
                          <Spinner animation="border" variant="teal" size="sm" className="me-2" />
                          <span>Memuat data ICD-9-CM dari /show_icdix...</span>
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-center text-muted">{indexOfFirst + idx + 1}</td>
                          <td className="text-center">
                            <Badge bg="teal" className="font-monospace text-white px-2 py-1" style={{ background: '#0d9488', fontSize: '0.75rem' }}>
                              {item.kode}
                            </Badge>
                          </td>
                          <td className="fw-semibold text-dark" style={{ fontSize: '0.78rem' }}>
                            {item.deskripsi}
                          </td>
                          <td className="text-center">
                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit Data ICD-9</Tooltip>}>
                              <Button
                                size="sm"
                                variant="outline-success"
                                style={{ padding: '0.15rem 0.5rem', fontSize: '0.72rem', borderRadius: '5px' }}
                                onClick={() => handleOpenFormModal(item)}
                              >
                                <i className="bi bi-pencil-square me-1"></i> Edit
                              </Button>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center py-4 text-muted">
                          Tidak ada data ICD-9-CM yang ditemukan.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
            </div>

            {/* ── Pagination ── */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3">
                <Pagination size="sm" className="mb-0">
                  <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                  <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                  {[...Array(Math.min(totalPages, 10))].map((_, i) => (
                    <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </Pagination.Item>
                  ))}
                  {totalPages > 10 && <Pagination.Ellipsis disabled />}
                  <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
                  <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                </Pagination>
              </div>
            )}

            {/* ── Footer Info ── */}
            <div className="d-flex justify-content-between mt-3 pt-2 border-top text-muted" style={{ fontSize: '0.72rem' }}>
              <span>
                Menampilkan{' '}
                <strong>{activeDataset.length > 0 ? indexOfFirst + 1 : 0}–{Math.min(indexOfLast, activeDataset.length)}</strong>{' '}
                dari <strong>{activeDataset.length}</strong> data {activeTab === 'icd10im' ? 'ICD-10 IM' : activeTab === 'icd9im' ? 'ICD-9 IM' : activeTab === 'icd10' ? 'ICD-10' : 'ICD-9-CM'} (Total: {activeTab === 'icd10im' ? icd10ImList.length : activeTab === 'icd9im' ? icd9ImList.length : activeTab === 'icd10' ? icdList.length : icd9List.length})
              </span>
              <span>IP Server: <strong>{getApiUrl()}</strong></span>
            </div>
          </Card.Body>
        </Card>
      </div>

      {/* ══ MODAL FORM TAMBAH / EDIT DATA ICD ══ */}
      <Modal show={showFormModal} onHide={() => setShowFormModal(false)} centered backdrop="static">
        <Modal.Header
          closeButton
          style={{
            background: activeTab === 'icd10im'
              ? 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)'
              : activeTab === 'icd10'
                ? 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)'
                : 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)',
            color: '#fff'
          }}
        >
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className={`bi ${activeTab === 'icd10im' ? 'bi-file-earmark-medical-fill' : activeTab === 'icd10' ? 'bi-journal-plus' : 'bi-scissors'} text-warning fs-5`}></i>
            <span>
              {isEditMode
                ? `Edit Data ${activeTab === 'icd10im' ? 'ICD-10 IM' : activeTab === 'icd10' ? 'ICD-10' : 'ICD-9-CM'}`
                : `Tambah Data ${activeTab === 'icd10im' ? 'ICD-10 IM' : activeTab === 'icd10' ? 'ICD-10' : 'ICD-9-CM'} Baru`}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleSaveForm}>
            {activeTab === 'icd10im' ? (
              /* FORM ICD-10 IM */
              <Row className="g-2">
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      Kode ICD-10 IM <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Contoh: A00.0 atau Z38.0"
                      value={formDataIcd10Im.kode}
                      onChange={e => setFormDataIcd10Im({ ...formDataIcd10Im, kode: e.target.value })}
                      disabled={isEditMode}
                      required
                      style={{ fontSize: '0.82rem', fontWeight: '600' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      No. DTD
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Contoh: 001"
                      value={formDataIcd10Im.dtd}
                      onChange={e => setFormDataIcd10Im({ ...formDataIcd10Im, dtd: e.target.value })}
                      style={{ fontSize: '0.82rem' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      Nama Penyakit / Diagnosa (Indonesia)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Contoh: Kolera atau Bayi tunggal lahir di RS"
                      value={formDataIcd10Im.penyakit}
                      onChange={e => setFormDataIcd10Im({ ...formDataIcd10Im, penyakit: e.target.value })}
                      style={{ fontSize: '0.82rem' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      Deskripsi ICD-10 IM (English / Baku) <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Contoh: Cholera due to Vibrio cholerae 01, biovar cholerae"
                      value={formDataIcd10Im.deskripsi}
                      onChange={e => setFormDataIcd10Im({ ...formDataIcd10Im, deskripsi: e.target.value })}
                      required
                      style={{ fontSize: '0.8rem' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      Keterangan Sifat Penyakit
                    </Form.Label>
                    <Form.Select
                      value={formDataIcd10Im.keterangan}
                      onChange={e => setFormDataIcd10Im({ ...formDataIcd10Im, keterangan: e.target.value })}
                      style={{ fontSize: '0.82rem' }}
                    >
                      <option value="TIDAK MENULAR">TIDAK MENULAR</option>
                      <option value="MENULAR">MENULAR</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            ) : activeTab === 'icd10' ? (
              /* FORM ICD-10 */
              <Row className="g-2">
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      Kode ICD-10 <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Contoh: A00.0"
                      value={formDataIcd10.icd}
                      onChange={e => setFormDataIcd10({ ...formDataIcd10, icd: e.target.value })}
                      disabled={isEditMode}
                      required
                      style={{ fontSize: '0.82rem', fontWeight: '600' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      No. DTD
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Contoh: 001"
                      value={formDataIcd10.dtd}
                      onChange={e => setFormDataIcd10({ ...formDataIcd10, dtd: e.target.value })}
                      style={{ fontSize: '0.82rem' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      Nama Penyakit (Bahasa Indonesia) <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Contoh: Kolera"
                      value={formDataIcd10.penyakit}
                      onChange={e => setFormDataIcd10({ ...formDataIcd10, penyakit: e.target.value })}
                      required
                      style={{ fontSize: '0.82rem' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      Deskripsi ICD-10 (Bahasa Inggris / Detail)
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Contoh: Cholera due to Vibrio cholerae 01, biovar cholerae"
                      value={formDataIcd10.nm_icd}
                      onChange={e => setFormDataIcd10({ ...formDataIcd10, nm_icd: e.target.value })}
                      style={{ fontSize: '0.8rem' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      Keterangan Sifat Penyakit
                    </Form.Label>
                    <Form.Select
                      value={formDataIcd10.keterangan}
                      onChange={e => setFormDataIcd10({ ...formDataIcd10, keterangan: e.target.value })}
                      style={{ fontSize: '0.82rem' }}
                    >
                      <option value="MENULAR">MENULAR</option>
                      <option value="TIDAK MENULAR">TIDAK MENULAR</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            ) : (
              /* FORM ICD-9 */
              <Row className="g-2">
                <Col md={12}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      Kode ICD-9-CM <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Contoh: 01.01 atau 68.29"
                      value={formDataIcd9.kode}
                      onChange={e => setFormDataIcd9({ ...formDataIcd9, kode: e.target.value })}
                      disabled={isEditMode}
                      required
                      style={{ fontSize: '0.82rem', fontWeight: '600' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                      Deskripsi Prosedur / Tindakan (ICD-9-CM) <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Contoh: Cisternal puncture"
                      value={formDataIcd9.deskripsi}
                      onChange={e => setFormDataIcd9({ ...formDataIcd9, deskripsi: e.target.value })}
                      required
                      style={{ fontSize: '0.82rem' }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {formFeedback && (
              <div className={`alert alert-${formFeedback.type} py-1 px-2 mb-3`} style={{ fontSize: '0.73rem' }}>
                <i className="bi bi-info-circle-fill me-1"></i>
                {formFeedback.text}
              </div>
            )}

            <div className="d-flex justify-content-end gap-2 border-top pt-2">
              <Button type="button" variant="secondary" size="sm" onClick={() => setShowFormModal(false)} disabled={isSaving}>
                Batal
              </Button>
              <Button
                type="submit"
                size="sm"
                variant={activeTab === 'icd10im' ? 'primary' : activeTab === 'icd10' ? 'success' : 'teal'}
                className="fw-bold text-white"
                disabled={isSaving}
                style={{
                  background: activeTab === 'icd10im'
                    ? 'linear-gradient(135deg, #1e40af 0%, #2563eb 100%)'
                    : activeTab === 'icd9'
                      ? '#0d9488'
                      : undefined
                }}
              >
                {isSaving ? <Spinner size="sm" animation="border" className="me-1" /> : <i className="bi bi-save me-1"></i>}
                Simpan Data {activeTab === 'icd10im' ? 'ICD-10 IM' : activeTab === 'icd10' ? 'ICD-10' : 'ICD-9'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 40%, #e2e8f0 100%)',
    display: 'flex', flexDirection: 'column',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.25rem 1rem', flexShrink: 0,
  },
  mainContent: {
    flex: 1, padding: '0.4rem', overflowY: 'auto',
  },
  mainCard: {
    borderRadius: '12px', border: '1.5px solid #cbd5e1',
    boxShadow: '0 8px 30px rgba(15, 23, 42, 0.06)',
    background: '#ffffff', overflow: 'hidden',
  },
  cardHeader: {
    padding: '0.4rem 0.75rem', color: '#ffffff', fontWeight: 600, fontSize: '0.83rem',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
};

export default DataIcd;
